/*USER LIST*/
var user_list = Vue.component('userlist', {
    template:'#userlist-template',

    data:function(){
        return{
            list: [],
            searchString:'',
            modal:'',
            active_tab: true
        };
    },
    created:function(){

        activeInstance = this;
        activeInstance.modal = $('body').find('#create_user_modal').html();

        showLoadingOverlay();
        Vue.http.get(baseURL+'/api/user/list/all',function(response){
            $('body').LoadingOverlay("hide");
            activeInstance.list=response;

            setTimeout(function(){
                var $table = $('.fixed_header_table');
                $table.floatThead({
                    top:70
                });
/*
                setTimeout(function(){
                    var $table = $('.fixed_header_table');
                    $table.floatThead({
                        top:65
                    });

                    //$('.responsive-table').footable();

                },200);
               */ 
            },200);
        }).bind(this);
    },

    methods:{
        create:function() {
            var datetime;
            setTimeout(function() {
                datetime = $('.bootbox.modal #popup_datetimepicker').datetimepicker({
                    format: 'YYYY-MM-DD',
                    locale: 'hu',
                });
            },500);
            
            bootbox.dialog({
                    title: "Új felhasználó hozzáadása",
                    message: this.modal,
                    buttons: {
                        success: {
                            label: "Save",
                            className: "btn-success",
                            callback: function () {

                                $('.field').removeClass('error');
                                var validation = true;

                                //VALIDATE EVERYTHING!!
                                var first_name	=  $('.bootbox-body').find('#field_first_name').val();
                                var last_name	=  $('.bootbox-body').find('#field_last_name').val();
                                var email		=  $('.bootbox-body').find('#field_email').val();
                                var basic_role  =  ($("#modal_create_client #user_basic_role_freelancer:checked").val()) ? 'freelancer': 'user';

                                if(basic_role == "user"){

                                    var total_days_off =  $(".bootbox-body #total_days_off").val();
                                    var first_business_day = datetime[0].value;

                                    if (total_days_off < 0 || total_days_off == '') {
                                        validation = false;
                                        errorNotification('Szabadnapok száma megadása kötelező');
                                        $('.bootbox-body').find('#total_days_off').addClass('error');
                                    }

                                    if (datetime[0].value == "") {
                                        validation = false;
                                        errorNotification('Első munkanap megadása kötelező');
                                        $('.bootbox-body').find('#popup_datetimepicker').addClass('error');
                                    }
                                } else {
                                    var total_days_off =  null;
                                    var first_business_day = null;
                                }

                                if(last_name.length < 2){
                                    validation = false;
                                    errorNotification('A keresztnév túl rövid!');
                                    $('.bootbox-body').find('#field_last_name').addClass('error');
                                }

                                if(validateEmail(email) == false){
                                    validation = false;
                                    errorNotification('Az email cím nem megfelelő!');
                                    $('.bootbox-body').find('#field_email').addClass('error');
                                }

                                if(validation == true) {
                                    
                                    activeInstance.$http.post(baseURL+'/admin/user/create', {
                                        first_name:first_name,
                                        last_name:last_name,
                                        email:email,
                                        basic_role: basic_role,
                                        total_days_off: total_days_off,
                                        first_business_day: first_business_day
                                    }).then(function(response) {

                                        if (response.data.error) {
                                            errorNotification(response.data.error);
                                            if (response.data.type == 'email') {
                                                $('.bootbox-body').find('#field_email').addClass('error');
                                            } else if (response.data.type == 'name') {
                                                $('.bootbox-body').find('#field_first_name').addClass('error');
                                                $('.bootbox-body').find('#field_last_name').addClass('error');
                                            }
                                            return false;
                                        }

                                        activeInstance.list.push(response.data);
                                        location.href=baseURL+'/admin/user/edit/'+response.data.id;

                                        bootbox.hideAll();
                                    });

                                    return false;
                                } else {
                                    return false;
                                }
                            }
                        }
                    }
                }
            );

            /*
        bootbox.prompt('Új felhasználó email címe:',function(value){
            Vue.http.post(baseURL+'/admin/user/create',{email:value}).then(function(response){
                activeInstance.list.push(response.data);
            });
        });
        */

        },
        edit:function(user){
            location.href = baseURL+'/admin/user/edit/'+user.id;
        },
        destroy:function(user){
            bootbox.confirm('Biztosan el akarod távolítani ezt a felhasználót?', function(value){
                if(value==true){
                    showLoadingOverlay();
                    Vue.http.post(baseURL+'/admin/user/destroy',{user:user}).then(function(response){
                        $('body').LoadingOverlay("hide");
                        successNotification('A felhasználó törölve.');
                        activeInstance.list.$remove(user);
                    });
                }
            });
        }
    }
});

function changedNewUserType(event) {
    if (event.target.value == 'freelancer') {
        $(".bootbox.modal .user_section").addClass("d-none");
    } else {
        $(".bootbox.modal .user_section").removeClass("d-none");
    }
}